import { getServiceClauseApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getServiceClauseApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
